import React from 'react';
import './Header.css';

const Header = () => {
    return (
        <header className="header">
            <h1 className="logo">voly</h1>
        </header>
    );
};

export default Header;
